import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { getConfigSnapshot } from "@/helpers/config";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";

export const useConfigurationQueries = () => {
  const api = useApi();

  return {
    listAppBrandings: () =>
      queryOptions({
        queryKey: QUERY_KEYS.CONFIGURATIONS_APP_BRANDING_LIST(),
        queryFn: api.getConfigurationBrandsV1,
        select: commonAPIDataSelector,
        staleTime: Infinity,
        gcTime: Infinity,
      }),
  };
};

/** The SDK owns retries and its cache policy; Query shares the loaded snapshot across app consumers. */
export function applicationConfigQueryOptions() {
  return queryOptions({
    queryKey: ["application-config"],
    queryFn: getConfigSnapshot,
    staleTime: Infinity,
    retry: false,
  });
}
